(function (app, ng) {

    app.directive("dragScroll",
        [
            "$window", "$document", "$parse", function ($window, $document, $parse) {
                return {
                    restrict: "A",
                    link: function (scope, element, attrs) {
                        var enabled = true;
                        var pushed = false;
                        var startClientX, startClientY, lastClientX, lastClientY;
                        var onDragEnd = $parse(attrs.onDragEnd);
                        var onDragStart = $parse(attrs.onDragStart);
                        var excludedClasses = attrs.dragScrollExcludedClasses ? attrs.dragScrollExcludedClasses.split(",") : [];

                        scope.$watch(attrs.dragScroll, function (newValue) {
                            enabled = newValue !== undefined ? newValue : true;
                        });

                        element.on("mousedown", handleMouseDown);

                        scope.$on("$destroy",
                            function () {
                                element.off("mousedown", handleMouseDown);
                                ng.element($window).off("mouseup", handleMouseUp);
                                ng.element($window).off("mousemove", handleMouseMove);
                            });

                        function handleMouseDown(event) {
                            if (enabled) {
                                for (var i = 0; i < excludedClasses.length; i++) {
                                    if (ng.element(event.target).hasClass(excludedClasses[i])) {
                                        return true;
                                    }
                                }

                                scope.$apply(function () {
                                    onDragStart(scope);
                                });

                                ng.element($window).on("mouseup", handleMouseUp);
                                ng.element($window).on("mousemove", handleMouseMove);

                                pushed = true;
                                lastClientX = startClientX = event.clientX;
                                lastClientY = startClientY = event.clientY;

                                if ($window.getSelection) {
                                    if ($window.getSelection().empty) {
                                        $window.getSelection().empty();
                                    } else if ($window.getSelection.removeAllRanges) {
                                        window.getSelection().removeAllRanges();
                                    }
                                } else if ($document.selection) {
                                    $document.selection.empty();
                                }
                            }
                        }

                        function handleMouseUp(event) {
                            if (enabled) {
                                var selectable = (event.target.attributes && "drag-scroll-text" in event.target.attributes);
                                var withinX = (event.clientX >= (startClientX - 5) && event.clientX <= (startClientX + 5));
                                var withinY = (event.clientY >= (startClientY - 5) && event.clientY <= (startClientY + 5));

                                pushed = false;

                                if (selectable && withinX && withinY) {
                                    var range;
                                    if ($window.document.selection) {
                                        range = $window.document.body.createTextRange();
                                        range.moveToElementText(element);
                                        range.select();
                                    } else if ($window.getSelection) {
                                        range = $window.document.createRange();
                                        range.selectNode(element);
                                        $window.getSelection().addRange(range);
                                    }
                                }

                                scope.$apply(function () {
                                    onDragEnd(scope);
                                });

                                ng.element($window).off("mouseup", handleMouseUp);
                                ng.element($window).off("mousemove", handleMouseMove);
                            }
                        }

                        function handleMouseMove(event) {
                            if (enabled) {
                                if (pushed) {
                                    element[0].scrollLeft -= (-lastClientX + (lastClientX = event.clientX));
                                    element[0].scrollTop -= (-lastClientY + (lastClientY = event.clientY));
                                }
                            }
                        }
                    }
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line